import React, { useEffect, useState } from "react";
import CaseUploadForm from "../../../components/Utils/CaseUploadForm";
import {
    addWorkerCommittee,
    uploadOfflineCase,
} from "../../../Adapters/OfflineCasesCalls";
import { useRecoilState } from "recoil";
import { userState } from "../../../RecoilState/userState";
import useCategories from "../../../hooks/useCategories";
import { Form, message } from "antd";
import dayjs from "dayjs";
import { getWorkerCommittee } from "../../../Adapters/CaseReportCalls";
import { useNavigate } from "react-router";
const warningMessage =
    "Please avoid including any personal information about the worker in the “Case Details” or “Remarks”; such as their name, ID, or phone number. This is to ensure their privacy and anonymity.";

const WorkerCommitteeOfflineCaseUpload = ({ departmentValues }) => {
    const navigate = useNavigate();
    const [isDocumentUploaded, setIsDocumentUploaded] = useState(false);
    const [documentFileList, setDocumentFileList] = useState([]);
    const [uploadFinished, setUploadFinished] = useState(false);
    const onUploadComplete = () => {
        setUploadFinished(true);
        navigate("/home/OfflineCases");
    };
    const [workerCommitteeOptions, setWorkerCommitteeOptions] = useState([]);
    const [uploadedFileID, setUploadedFileID] = useState("");
    const [user] = useRecoilState(userState);
    const { categoryOptions, subCategoryOptions, updateSubCategoryOptions } =
        useCategories(user.company_fk);
    const [form] = Form.useForm();
    const [committeeNameValue, setCommitteeNameValue] = useState({
        id: null,
        fieldrename: "",
        addField: "",
        newFieldName: "",
    });
    const [handleCommitteeDropdown, setHandleCommitteeDropdown] = useState({
        open: false,
        edit: false,
        editId: null,
        disableInput: true,
        refreshRegion: true,
    });

    const fieldsData = [
        {
            type: "date",
            label: "Issue Date",
            name: "date",
            colSpan: 12,
            placeholder: "Select Issue Date",
            rules: [{ required: true, message: "Please select issue date!" }],
            disableFutureDates: true,
        },
        {
            type: "select",
            label: "Concerned Dept.",
            name: "concerned_dept",
            colSpan: 12,
            options: departmentValues,
            placeholder: "Select Concerned Dept",
            rules: [
                { required: true, message: "Please select concerned dept!" },
            ],
        },
        {
            type: "addEditDropdown",
            label: "Committee Name",
            name: "committee_name",
            colSpan: 12,
            placeholder: "Enter Committee Name",
            fields: workerCommitteeOptions,
            rules: [
                { required: true, message: "Please input Committee Name!" },
            ],
            fieldValue: committeeNameValue,
            setFieldValue: setCommitteeNameValue,
            handleDropdown: handleCommitteeDropdown,
            setHandleDropdown: setHandleCommitteeDropdown,
            allowSpaces: true,
        },
        {
            type: "date",
            label: "Resolution Date",
            name: "resolution_date",
            colSpan: 12,
            placeholder: "Select Resolution Date",
            rules: [
                { required: true, message: "Please select resolution date!" },
            ],
            disableFutureDates: true,
        },
        {
            type: "select",
            label: "Case Nature",
            name: "case_nature",
            colSpan: 12,
            options: [
                { label: "Complaint", value: "Complaint" },
                { label: "Query", value: "Query" },
                { label: "Suggestion", value: "Suggestion" },
            ],
            placeholder: "Select Case Nature",
            rules: [{ required: true, message: "Please select case nature!" }],
        },
        {
            type: "input",
            label: "Resolution Provided",
            name: "resolution_provided",
            colSpan: 12,
            placeholder: "Enter Resolution",
            rules: [
                {
                    required: true,
                    message: "Please select Resolution Provided",
                },
            ],
        },
        {
            type: "select",
            label: "Category",
            name: "category",
            colSpan: 12,
            options: categoryOptions,
            placeholder: "Select Category",
            rules: [{ required: true, message: "Please select category!" }],
        },
        {
            type: "upload",
            label: "Documents",
            name: "file",
            model: "offline_documents",
            allowedFileTypes: [
                "pdf",
                "doc",
                "docx",
                "jpeg",
                "jpg",
                "png",
                "svg",
            ],
            colSpan: 12,
            placeholder: "Attach supporting media",
            fileList: documentFileList,
            setFileList: setDocumentFileList,
            handleUpload: isDocumentUploaded,
            setHandleUpload: setIsDocumentUploaded,
            onUploadComplete: onUploadComplete,
        },
        {
            type: "select",
            label: "Sub Category",
            name: "subCategory",
            colSpan: 12,
            options: subCategoryOptions,
            placeholder: "Select Sub Category",
            rules: [{ required: true, message: "Please select sub category!" }],
        },
        {
            type: "textarea",
            label: "Case Details",
            name: "case_details",
            colSpan: 12,
            placeholder: "Enter Case Details",
            rules: [
                { required: true, message: "Please provide case details!" },
            ],
        },
        {
            type: "textarea",
            label: "Remarks",
            name: "remarks",
            colSpan: 12,
            placeholder: "Enter Remarks",
        },
    ];
    const fetchWorkerCommittee = async () => {
        try {
            const res = await getWorkerCommittee(user.factory_fk);
            setWorkerCommitteeOptions(res.data?.message_body?.WorkerCommittee);
        } catch (error) {
            console.error("Error fetching worker committee options:", error);
        }
    };
    useEffect(() => {
        fetchWorkerCommittee();
    }, [user.factory_fk]);

    useEffect(() => {
        form.setFieldsValue({ file: documentFileList });
    }, [documentFileList]);

    const resetFields = () => {
        form.resetFields();
        setUploadFinished(false);
        if (documentFileList.length <= 0) {
            navigate("/home/OfflineCases");
        }
    };
    useEffect(() => {
        if (!committeeNameValue.id && committeeNameValue.newFieldName) {
            form.setFieldValue(
                "committee_name",
                committeeNameValue?.newFieldName
            );
        } else {
            form.setFieldValue("committee_name", committeeNameValue.id);
        }
    }, [committeeNameValue]);
    const handleSubmit = async (values) => {
        try {
            if (!committeeNameValue.id && committeeNameValue.newFieldName) {
                const data = {
                    Name: committeeNameValue.newFieldName,
                };

                await addWorkerCommittee(data)
                    .then((res) => {
                        form.setFieldValue(
                            "committee_name",
                            res.data.message_body.id
                        );
                        message.success(res.data.message);
                    })
                    .catch((error) => {
                        message.error(error?.response?.data?.errorMessage);
                        return;
                    });
            } else {
                form.setFieldValue("committee_name", committeeNameValue.id);
            }
        } catch {
            return;
        }
        try {
            const data = {
                factory: user.factory_fk,
                date: dayjs(values.date).format("YYYY-MM-DD"),
                concerned_dept: values.concerned_dept,
                worker_committee: [form.getFieldValue("committee_name")],
                resolution_date: dayjs(values.resolution_date).format(
                    "YYYY-MM-DD"
                ),
                medium: values.medium,
                resolution_provided: values.resolution_provided,
                case_nature: values.case_nature,
                category: values.subCategory,
                case_details: values.case_details,
                remarks: values.remarks,
                case_type: "Worker Committee",
            };
            const res = await uploadOfflineCase(data);
            setUploadedFileID(res.data.id);
            setIsDocumentUploaded(true);
            resetFields();
            message.success(res.data.message);
        } catch (error) {
            console.error("Error uploading case:", error);
        }
    };

    const handleValuesChange = (changedValues) => {
        if (changedValues.category) {
            updateSubCategoryOptions(changedValues.category);
            form.setFieldsValue({ subCategory: undefined }); // Reset subcategory field
        }
    };

    return (
        <div>
            <CaseUploadForm
                form={form}
                fieldsData={fieldsData}
                handleSubmit={handleSubmit}
                handleValuesChange={handleValuesChange}
                warningMessage={warningMessage}
                caseID={uploadedFileID}
            />
        </div>
    );
};

export default WorkerCommitteeOfflineCaseUpload;
